import React from 'react';
import { AlertCircle } from 'lucide-react';

const Alert = ({ type = 'info', message, action, actionLabel }) => {
  const styles = {
    warning: {
      bg: 'bg-amber-100',
      border: 'border-amber-400',
      text: 'text-amber-800',
      icon: 'text-amber-600',
      button: 'bg-amber-600 hover:bg-amber-700'
    },
    info: {
      bg: 'bg-blue-100',
      border: 'border-blue-400',
      text: 'text-blue-800',
      icon: 'text-blue-600',
      button: 'bg-blue-600 hover:bg-blue-700'
    },
    error: {
      bg: 'bg-red-100',
      border: 'border-red-400',
      text: 'text-red-800',
      icon: 'text-red-600',
      button: 'bg-red-600 hover:bg-red-700'
    }
  };

  const style = styles[type] || styles.info;

  return (
    <div className={`${style.bg} border-b-2 ${style.border} px-6 py-3`}>
      <div className="max-w-4xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AlertCircle className={style.icon} size={20} />
          <p className={`${style.text} font-medium`}>{message}</p>
        </div>
        {action && actionLabel && (
          <button 
            onClick={action}
            className={`${style.button} text-white px-4 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap`}
          >
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default Alert;

